"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAlertInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconAlertInfo = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M20.486 3.515C15.8-1.171 8.2-1.172 3.515 3.515c-4.687 4.686-4.686 12.284 0 16.97 4.686 4.686 12.284 4.687 16.97 0 4.687-4.686 4.686-12.284 0-16.97zm-6.921 13.703a1.565 1.565 0 11-3.13 0v-6.261a1.565 1.565 0 113.13 0v6.26zM11.972 8.28c-.902 0-1.503-.638-1.484-1.427-.019-.826.582-1.446 1.502-1.446s1.503.62 1.522 1.446c0 .789-.6 1.427-1.54 1.427z"
}));
exports.IconAlertInfo = IconAlertInfo;
//# sourceMappingURL=IconAlertInfo.js.map